export class EarlyAccess {
    public feature: string;
    public scope: string;
  }
